var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBenjaminHoveLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "647b3a2cd0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.78125 88 L 368.53125 88 L 368.53125 369.246094 L 7.78125 369.246094 Z M 7.78125 88 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 13551086000
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.78125 8.496094 L 368.53125 8.496094 L 368.53125 283 L 7.78125 283 Z M 7.78125 8.496094 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#647b3a2cd0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7de19a",
    d: "M 332.351562 89.414062 L 331.222656 89.414062 L 331.222656 170.78125 L 236.40625 170.78125 L 236.40625 89.414062 L 199.96875 89.414062 L 199.96875 282.503906 L 236.40625 282.503906 L 236.40625 204.441406 L 331.222656 204.441406 L 332.351562 333.066406 L 43.84375 333.066406 L 43.84375 311.730469 L 7.78125 311.730469 L 7.78125 369.128906 L 368.414062 369.128906 L 368.414062 88.8125 Z M 332.351562 89.414062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#13551086e3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7de19a",
    d: "M 7.78125 8.496094 L 7.78125 282.277344 L 43.84375 282.277344 L 43.84375 282.203125 C 63.152344 282.203125 82.386719 282.203125 101.769531 282.203125 C 141.742188 282.203125 174.046875 268.378906 174.046875 225.402344 C 174.046875 213.230469 165.78125 189.265625 143.167969 182.351562 C 161.125 174.386719 168.261719 160.039062 168.261719 145.085938 C 168.261719 106.167969 139.863281 89.113281 101.769531 89.113281 C 82.460938 89.113281 63.152344 89.113281 43.84375 89.113281 L 43.84375 44.5625 L 332.351562 44.5625 L 332.351562 59.285156 L 368.414062 59.285156 L 368.414062 8.496094 Z M 46.023438 122.171875 L 101.769531 122.171875 C 124.910156 122.171875 132.125 137.046875 132.125 145.914062 C 132.125 156.957031 124.6875 166.574219 101.769531 166.574219 L 46.023438 166.574219 Z M 46.023438 198.582031 L 101.769531 198.582031 C 116.648438 198.582031 137.910156 207.671875 137.910156 225.027344 C 137.910156 243.210938 116.648438 248.167969 101.769531 248.167969 L 46.023438 248.167969 Z M 46.023438 198.582031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenjaminHoveLogo);
export default __webpack_public_path__ + "static/media/benjamin-hove-logo.145ea38efb1b976cf9d8ef8a7700bf71.svg";
export { ForwardRef as ReactComponent };